import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { UnsubscribeNewsletterPage } from 'features/emailUnsubscribe'
import { z } from 'zod/v4'

export const newsletterUnsubscribeSchema = z.object({
  token: z.string().optional(),
  type: z.string().optional(),
})

export type NewsletterUnsubscribeSchemaSearch = z.infer<typeof newsletterUnsubscribeSchema>

export const Route = createFileRoute('/newsletter/unsubscribe')({
  component: UnsubscribeNewsletterPage,
  validateSearch: newsletterUnsubscribeSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Unsubscribe from newsletter'),
      },
    ],
  }),
})
